export const downloadFile = ({
  payload,
  filename,
  fileExtension,
}: {
  payload: Blob;
  filename: string;
  fileExtension: string;
}): void => {
  const url = window.URL.createObjectURL(payload);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${filename}.${fileExtension}`);
  document.body.appendChild(link);
  link.click();
  // Cleanup
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export default downloadFile;
